(function($, undefined) {

	'use strict';
	var locationGeo; 
	
	var geolocalizePopup;
	var geolocalizePopupBtnClose;
	var geolocalizeMeBtn;
	var geolocalizeMeBtnSave;
    
    var recherchePannelLocationSearch;

	var openGeolocalizePopup = function () {
		$("#blackout").css("display", "block");
		geolocalizePopup.addClass('open');
	};
    
    var closeGeolocalizePopup = function (e, empty) {
        geolocalizePopup = $(".localize-popup");
        $("#blackout").css("display", "none");
        geolocalizePopup.removeClass('open');

        if (empty) {
            $(".recherche-pannel-index-mot-label-input.location-geo").val("");
        }

        saveSessionVariable('popupFilled', "true", function () {});
    };
	
	// Try HTML5 geolocation.
	var geolocalizeMe = function (e) {
		if (navigator.geolocation) {
			var t = $(this);
			navigator.geolocation.getCurrentPosition(function (position) {
//				 var pos = {
//				     lat: 45.592134,
//				     lng: -73.437113
//				 };
				var pos = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};
				
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({'location': pos}, function (results, status) {
					if (status === 'OK') {
						if (results[0]) {
							processInfo(results[0], $(t).closest(".ref-ctn"));
						} else {
							window.alert('No results found');
						}
					} else {
						window.alert('Geocoder failed due to: ' + status);
					}
				});
			}, function () {
				console.log("no support");
			});
		} else {
			// Browser doesn't support Geolocation
			console.log("no support accepted");
		}
	};
	
    var geolocalizeMeSave = function (callback) {
        $(".recherche-pannel-index-mot-label-input.location").val($('.localize-popup-location').val());

        var url = window.location.href;
        url = updateQueryStringParameter(url, 'place', encodeURIComponent($('.localize-popup-location').val()));
        url = updateQueryStringParameter(url, 'field11', encodeURIComponent($('.localize-popup-field11').val()));
        url = updateQueryStringParameter(url, 'field12', encodeURIComponent($('.localize-popup-field12').val()));
       // window.alert($('.localize-popup-field13').val());
        url = updateQueryStringParameter(url, 'field13', encodeURIComponent($('.localize-popup-field13').val()));
        url = updateQueryStringParameter(url, 'sort', "proximity");

        url = updateQueryStringParameter(url, 'lat', encodeURIComponent($('.localize-popup-lat').val()));
        url = updateQueryStringParameter(url, 'lng', encodeURIComponent($('.localize-popup-lng').val()));
        
        var count = 7;
        var _complete = function(e) {
            if (--count <= 0) {
                if ($('.localize-popup-serve').val() === '') {
                    saveSessionVariable('serve', '1', function(e) {
                        if ($(".ref-ctn").attr('data-reload') === 'true') {
                            window.location.href = url;
                        } else {
                            if ($('.localize-popup-field13').val() !== '') {
                                $(".localize-locality").find(".locality").text($('.localize-popup-field13').val());
                            } else {
                                $(".localize-locality").find(".locality").text($('.localize-popup-location').val());
                            }
                            if ($(".recherche-pannel-categorie-liste").length !== 0) {
                                $(".recherche-pannel-categorie-liste").attr("data-start-search", "true");
                                $(".recherche-pannel-categorie-liste").attr("data-lat", $('.localize-popup-lat').val());
                                $(".recherche-pannel-categorie-liste").attr("data-lng", $('.localize-popup-lng').val());
                            }
                            closeGeolocalizePopup(e, false);
                            if (typeof callback === 'function') {
                                callback();
                            }
                        }
                    });
                } else {
                    if ($(".ref-ctn").attr('data-reload') === 'true') {
                        window.location.href = url;
                    } else {
                        if ($('.localize-popup-field13').val() !== '') {
                            $(".localize-locality").find(".locality").text($('.localize-popup-field13').val());
                        } else {
                            $(".localize-locality").find(".locality").text($('.localize-popup-location').val());
                        }
                        if ($(".recherche-pannel-categorie-liste").length !== 0) {
                            $(".recherche-pannel-categorie-liste").attr("data-start-search", "true");
                            $(".recherche-pannel-categorie-liste").attr("data-lat", $('.localize-popup-lat').val());
                            $(".recherche-pannel-categorie-liste").attr("data-lng", $('.localize-popup-lng').val());
                        }
                        closeGeolocalizePopup(e, false);
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                }
            }
        };
        saveSessionVariable('location', $('.localize-popup-location').val(), _complete);
        saveSessionVariable('lat', encodeURIComponent($('.localize-popup-lat').val()), _complete);
        saveSessionVariable('lng', encodeURIComponent($('.localize-popup-lng').val()), _complete);
        saveSessionVariable('field11', encodeURIComponent($('.localize-popup-field11').val()), _complete);
        saveSessionVariable('field12', encodeURIComponent($('.localize-popup-field12').val()), _complete);
        saveSessionVariable('field13', encodeURIComponent($('.localize-popup-field13').val()), _complete);
        saveSessionVariable('popupFilled', "true", _complete);
    };

    var updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    };



// Globalize this function to be used in recherche. It's also to combine with manual automplete search when users are lazy to click on the dropdown
window.processInfoCat = function (url,place, ctn, callback) {
    //var ctn = $(".localize-popup");
    var streetNbr, street, formattedAddress;
    var city = '', neighbourhood = '';
    var instantSave = ctn.attr("data-instant-save") === "true";
    //window.alert("HERE WE GO");
    for (var i = 0; i < place.address_components.length; i++)
    {
        var addr = place.address_components[i];
        //window.alert(addr.types[0]+"------"+addr.long_name);
        if (addr.types[0] === 'sublocality' || addr.types[0] === 'neighborhood' || (addr.types[1] !== null && addr.types[1] === 'sublocality') || (addr.types[2] !== null && addr.types[2] === 'sublocality') || addr.types[0] === 'administrative_area_level_3'){
            neighbourhood = addr.long_name;
        }
        if (addr.types[0] === 'locality'||addr.types[0] === 'political'){
            city = addr.long_name;
            break ;
        }
        if (addr.types[0] === 'route'){
            street = addr.long_name;
        }
        if (addr.types[0] === 'street_number'){
            streetNbr = addr.long_name;
        }
    }


    
   // city =place.vicinity;

   // window.alert(city);
    if(place.formatted_address){
        formattedAddress = place.formatted_address;
    }

    if(neighbourhood === '' || (city !== 'Montr\xE9al' && city !== 'Montreal' && city !== 'Laval')){
        neighbourhood = city;
    }

    if(neighbourhood === 'Centre-ville'){
        neighbourhood = 'Ville-Marie';
    }

    if(neighbourhood === 'Quebec City'){
        neighbourhood = 'Qu\xE9bec';
    }

    if(formattedAddress !== undefined){
        $('.localize-popup-location').val(removeDiacritics(formattedAddress));
    } else if(street !== undefined){
        $('.localize-popup-location').val(removeDiacritics((streetNbr !== undefined) ?streetNbr + " " + street : street));
    } else if(neighbourhood !== undefined && neighbourhood !== ''){
        $('.localize-popup-location').val(removeDiacritics(neighbourhood));
    }
    locationGeo.val(place.formatted_address);
    var neigh = $(".localize-locality .locality", ctn);
    neigh.text(neighbourhood);
    $('.remove-locality').show();

    var found = false;

    var plainNeighourhood = encodeURI(neighbourhood).replaceAll("%E2%80%94"," ");
    plainNeighourhood = removeDiacritics(decodeURI(plainNeighourhood).replaceAll("-", " ").toLowerCase().replace(/[\u0300-\u036f]/g, "").replaceAll("–"," ").replaceAll("�"," ").replaceAll("�"," "));


    //window.alert("city:"+city);
    //window.alert("nebourhood :"+plainNeighourhood);


    $(".recherche-filtre-region", ctn).find("button.dropdown-select-pannel-item[data-value='all']").trigger("click");
    var villeItem = $(".recherche-filtre-ville", ctn).find("button.dropdown-select-pannel-item").filter(function(){
        var $_ = $(this);
        var region = encodeURI($_.attr("data-region")).replaceAll("%E2%80%94"," ");
        region = removeDiacritics(decodeURI(region).toLowerCase().replace(/[\u0300-\u036f]/g, "").replaceAll("-", " ").replaceAll("–"," ").replaceAll("�", " "));
        var territory = encodeURI($_.attr('data-value')).replaceAll("%E2%80%94"," ");
        territory = removeDiacritics(decodeURI(territory).toLowerCase().replace(/[\u0300-\u036f]/g, "").replaceAll("-", " ").replaceAll("–"," ").replaceAll("�", " "));
        if (!found && (region === plainNeighourhood || city === territory || territory === plainNeighourhood)) {
            $_.trigger("click");
            if (territory === plainNeighourhood) {
                city = $_.attr('data-value');
            } else if (region === plainNeighourhood && city !== $_.attr('data-value')) {
                city = '';
            }
            found = true;
            //window.alert("terr:"+territory);
            //window.alert("regio:"+region);
            return this;
        }
    });

    $(".dropdown-select-pannel").removeAttr("style");
    $('.localize-popup-lat').val(place.geometry.location.lat());
    $('.localize-popup-lng').val(place.geometry.location.lng());
    if (found) {
        // City found
        $('.geolocation-no-match').slideUp();
        $(".localize-popup-button-save").removeClass("disabled");
        $('.localize-popup-field11').val(villeItem.attr('data-region'));
        $('.localize-popup-field12').val(villeItem.attr('data-agglo'));
        $('.localize-popup-field13').val(removeDiacritics(city));
        url+='&field11='+villeItem.attr('data-region')+'&field12='+villeItem.attr('data-agglo')+'&field13='+removeDiacritics(city);
        //window.alert(villeItem.attr('data-region'));
        //window.alert(villeItem.attr('data-agglo'));
       
        if (instantSave) {
            geolocalizeMeSave(callback);
        }
    } else {
        if (neighbourhood === 'Montreal' || neighbourhood === 'Montr\xE9al' || neighbourhood === 'Laval') {
            // Montreal or Laval region found
            $('.geolocation-no-match').slideUp();
            $(".localize-popup-button-save").removeClass("disabled");
            $('.localize-popup-field11').val(neighbourhood);
            $('.localize-popup-field12').val(neighbourhood);
            $('.localize-popup-field13').val("");
            url+='&field11='+neighbourhood+'&field12='+neighbourhood;
            //window.alert(villeItem.attr('data-region'));
            if(instantSave){
                geolocalizeMeSave(callback);                    
            }
        } else {
            $(".localize-popup-button-save").addClass("disabled");
            $('.localize-popup-field11').val("");
            $('.localize-popup-field12').val("");
            $('.localize-popup-field13').val("");
            $('.geolocation-no-match').slideDown();
        }
    }

   // window.alert(url);
    return url;
};



    // Globalize this function to be used in recherche. It's also to combine with manual automplete search when users are lazy to click on the dropdown
    window.processInfo = function (place, ctn, callback) {
        //var ctn = $(".localize-popup");
        var streetNbr, street, formattedAddress;
        var city = '', neighbourhood = '';
        var instantSave = ctn.attr("data-instant-save") === "true";
        //window.alert("HERE WE GO");
        for (var i = 0; i < place.address_components.length; i++)
        {
            var addr = place.address_components[i];
            //window.alert(addr.types[0]+"------"+addr.long_name);
            if (addr.types[0] === 'sublocality' || addr.types[0] === 'neighborhood' || (addr.types[1] !== null && addr.types[1] === 'sublocality') || (addr.types[2] !== null && addr.types[2] === 'sublocality') || addr.types[0] === 'administrative_area_level_3'){
                neighbourhood = addr.long_name;
            }
            if (addr.types[0] === 'locality'){
                city = addr.long_name;
            }
            if (addr.types[0] === 'route'){
                street = addr.long_name;
            }
            if (addr.types[0] === 'street_number'){
                streetNbr = addr.long_name;
            }
        }

        city =place.vicinity;

       // window.alert(city);
        if(place.formatted_address){
            formattedAddress = place.formatted_address;
        }

        if(neighbourhood === '' || (city !== 'Montr\xE9al' && city !== 'Montreal' && city !== 'Laval')){
            neighbourhood = city;
        }

        if(neighbourhood === 'Centre-ville'){
            neighbourhood = 'Ville-Marie';
        }

        if(neighbourhood === 'Quebec City'){
            neighbourhood = 'Qu\xE9bec';
        }

        if(formattedAddress !== undefined){
            $('.localize-popup-location').val(removeDiacritics(formattedAddress));
        } else if(street !== undefined){
            $('.localize-popup-location').val(removeDiacritics((streetNbr !== undefined) ?streetNbr + " " + street : street));
        } else if(neighbourhood !== undefined && neighbourhood !== ''){
            $('.localize-popup-location').val(removeDiacritics(neighbourhood));
        }
        locationGeo.val(place.formatted_address);
        var neigh = $(".localize-locality .locality", ctn);
        neigh.text(neighbourhood);
        $('.remove-locality').show();

        var found = false;

        var plainNeighourhood = encodeURI(neighbourhood).replaceAll("%E2%80%94"," ");
        plainNeighourhood = removeDiacritics(decodeURI(plainNeighourhood).replaceAll("-", " ").toLowerCase().replace(/[\u0300-\u036f]/g, "").replaceAll("–"," ").replaceAll("�"," ").replaceAll("�"," "));

        $(".recherche-filtre-region", ctn).find("button.dropdown-select-pannel-item[data-value='all']").trigger("click");
        var villeItem = $(".recherche-filtre-ville", ctn).find("button.dropdown-select-pannel-item").filter(function(){
            var $_ = $(this);
            var region = encodeURI($_.attr("data-region")).replaceAll("%E2%80%94"," ");
            region = removeDiacritics(decodeURI(region).toLowerCase().replace(/[\u0300-\u036f]/g, "").replaceAll("-", " ").replaceAll("–"," ").replaceAll("�", " "));
            var territory = encodeURI($_.attr('data-value')).replaceAll("%E2%80%94"," ");
            territory = removeDiacritics(decodeURI(territory).toLowerCase().replace(/[\u0300-\u036f]/g, "").replaceAll("-", " ").replaceAll("–"," ").replaceAll("�", " "));
            if (!found && (region === plainNeighourhood || city === territory || territory === plainNeighourhood)) {
                $_.trigger("click");
                if (territory === plainNeighourhood) {
                    city = $_.attr('data-value');
                } else if (region === plainNeighourhood && city !== $_.attr('data-value')) {
                    city = '';
                }
                found = true;
               // window.alert(territory);
                //window.alert(region);
                return this;
            }
        });

        $(".dropdown-select-pannel").removeAttr("style");
        $('.localize-popup-lat').val(place.geometry.location.lat());
        $('.localize-popup-lng').val(place.geometry.location.lng());
        if (found) {
            // City found
            $('.geolocation-no-match').slideUp();
            $(".localize-popup-button-save").removeClass("disabled");
            $('.localize-popup-field11').val(villeItem.attr('data-region'));
            $('.localize-popup-field12').val(villeItem.attr('data-agglo'));
            $('.localize-popup-field13').val(removeDiacritics(city));
            //window.alert(villeItem.attr('data-region'));
            if (instantSave) {
                geolocalizeMeSave(callback);
            }
        } else {
            if (neighbourhood === 'Montreal' || neighbourhood === 'Montr\xE9al' || neighbourhood === 'Laval') {
                // Montreal or Laval region found
                $('.geolocation-no-match').slideUp();
                $(".localize-popup-button-save").removeClass("disabled");
                $('.localize-popup-field11').val(neighbourhood);
                $('.localize-popup-field12').val(neighbourhood);
                $('.localize-popup-field13').val("");
               // window.alert(villeItem.attr('data-region'));
                if(instantSave){
                    geolocalizeMeSave(callback);                    
                }
            } else {
                $(".localize-popup-button-save").addClass("disabled");
                $('.localize-popup-field11').val("");
                $('.localize-popup-field12').val("");
                $('.localize-popup-field13').val("");
                $('.geolocation-no-match').slideDown();
            }
        }
    };
	
	String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.replace(new RegExp(search, 'g'), replacement);
    };
    
	var createAutocomplete = function () {
		var request = {
			componentRestrictions: {country: "ca"}
		};
		
        locationGeo.each(function() {
            var input = this;
			// var autocompleteGeoloc = new google.maps.places.Autocomplete(locationGeo[0], request);
            // store the original event binding function
            var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

            function addEventListenerWrapper(type, listener) {
                // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
                // and then trigger the original listener.
                if (type == "keydown") {
                    var orig_listener = listener;
                    listener = function(event) {
                        var suggestion_selected = $(".pac-item-selected").length > 0;
                        if (event.which == 13 && !suggestion_selected) {
                            var simulated_downarrow = $.Event("keydown", {
                                keyCode: 40,
                                which: 40
                            });
                            orig_listener.apply(input, [simulated_downarrow]);
                        }

                        orig_listener.apply(input, [event]);
                    };
                }

                _addEventListener.apply(input, [type, listener]);
            }

            input.addEventListener = addEventListenerWrapper;
            input.attachEvent = addEventListenerWrapper;

            var autocomplete = new google.maps.places.Autocomplete(input, request);
            google.maps.event.addListener(autocomplete, 'place_changed', function() {
                var place = autocomplete.getPlace();
                processInfo(place, $(input).closest(".ref-ctn"));
            });
        });
	};

    var recherchePannelLocationSearchClick = function () {
        var t = $(this);
        var ctn = t.closest('.recherche-pannel-index-mot-item');
        var btn = $('.recherche-pannel-btn ', ctn);
        var url = btn.data('url');
        var catId = btn.data('cat-id');
        var subCatHandle = btn.data('sub-cat');
        var inputLocation = $('.recherche-pannel-index-mot-label-input.location', ctn);
        var location = removeDiacritics(inputLocation.val().split(',')[0]);
        var parent = t.closest(".recherche-pannel-categorie-liste");
        var startSearch = parent.attr("data-start-search");
        
        url += '?cat-id=' + catId;

        if (subCatHandle !== undefined) {
            url += '&sub-cat=' + subCatHandle;
        }
        if (parent.attr("data-lat") !== null && parent.attr("data-lat") !== undefined) {
            url += '&lat=' + parent.attr("data-lat");
        }
        if (parent.attr("data-lng") !== null && parent.attr("data-lng") !== undefined) {
            url += '&lng=' + parent.attr("data-lng");
            url += '&sort=proximity';
        }


        ///////


        ////

        
        //url += '&field11=Laval';
        url += '&place=' + inputLocation.val();
        if (removeDiacritics(inputLocation.val()).length !== 0) {
            var geocoder = new google.maps.Geocoder();
            if(parent.attr("data-lat") !== undefined && parent.attr("data-lat") !== undefined && parent.attr("data-lng") !== undefined && parent.attr("data-lng") !== undefined){                
                saveSessionVariable('location', location, function () {
                        saveSessionVariable('lat', parent.attr("data-lat"), function () {
                            saveSessionVariable('lng', parent.attr("data-lng"), function () {
                                url += "&sort=proximity";
                                //window.alert("1");
                                ///////

                                geocoder.geocode({'address': removeDiacritics(inputLocation.val())}, function (results, status) {
                                    if (status === 'OK') {
                                        if (results[0]) {
                                           var newUrl= processInfoCat(url,results[0], $(t).closest(".ref-ctn"), function(){
                                                //window.alert("2");
                                                //window.alert( parent.attr("data-region"));

                                                if(startSearch === null || startSearch !== 'true'){       
                                                    saveSessionVariable('serve', '0', function () {
                                                        //window.location.href = url;                                            
                                                    });
                                                } else {
                                                    //window.location.href = url;
                                                }
                                                        //window.location.href = url;   
                                                    });

                                                    //window.alert("11"+newUrl);
                                            window.location.href = newUrl; 
                                        } else {
                                            window.alert('No results found');
                                        }
                                    } else {
                                        window.alert('Geocoder failed due to: ' + status);
                                    }
                
                                });




                                ///////
                                
                            });
                        });
                });
            } else {
                geocoder.geocode({'address': removeDiacritics(inputLocation.val())}, function (results, status) {
                    if (status === 'OK') {
						if (results[0]) {
							var newUrl=processInfoCat(url,results[0], $(t).closest(".ref-ctn"), function(){
                                //window.alert("2");
                                //window.alert( parent.attr("data-region"));
                                        //window.location.href = url;   
                                    });
                                    //window.alert("22"+newUrl);
                                    window.location.href = newUrl;         
						} else {
							window.alert('No results found');
						}
					} else {
						window.alert('Geocoder failed due to: ' + status);
					}

                });
            }
        } else {
            window.location.href = url+"&sort=name";
        }
    };

	var init = function () {
		locationGeo = $('.location-geo');
		
		geolocalizePopup = $(".localize-popup");
		geolocalizePopupBtnClose = $(".localize-popup-button-close, .localize-popup-close");
		geolocalizeMeBtn = $(".localize-me-btn");
		geolocalizeMeBtnSave = $(".localize-popup-button-save");
        
		createAutocomplete();
		
		if (geolocalizePopup.length !== 0) {
			openGeolocalizePopup();
		}
		geolocalizePopupBtnClose.click(function(e){closeGeolocalizePopup(e, true);});
		geolocalizeMeBtn.click(geolocalizeMe);
		geolocalizeMeBtnSave.click(geolocalizeMeSave);
        
        recherchePannelLocationSearch = $('.recherche-pannel-btn.cat-location');
		
        recherchePannelLocationSearch.click(recherchePannelLocationSearchClick);
        
        $(document).keydown(function (e) {
            var ch = (typeof e.which == "number") ? e.which : e.keyCode;

            if (ch === 13 || ch === 10) {
                var googlePopup = $('.pac-container').filter(function () {
                    return $(this).css("position") === 'fixed';
                });

                $('.recherche-pannel-item-popup-content-location .recherche-pannel-index-mot-label-input.location').each(function () {
                    if ($(this).is(':focus') && googlePopup.length === 0) {
                        console.log($(this));
                        recherchePannelLocationSearchClick.apply($(this));
                    }
                });
            }
        });
	};

	$(init);
	
})(jQuery);